import { useMemo } from 'react';
import { useGetContractBeneficiariesQuery } from '../services/benefitApi';
import { BeneficiaryStatus } from '../types/voucher-beneficiaries';
const DEFAULT_LOCALE = 'pt-BR';
const filterWorkingBeneficiaries = (beneficiaries) => {
    return beneficiaries.filter(beneficiary => beneficiary.status === BeneficiaryStatus.WORKING);
};
const sortBeneficiariesAlphabetically = (beneficiaries) => {
    return [...beneficiaries].sort((a, b) => {
        const nameA = `${a.firstName.trim()} ${a.lastName.trim()}`.toLowerCase();
        const nameB = `${b.firstName.trim()} ${b.lastName.trim()}`.toLowerCase();
        return nameA.localeCompare(nameB, DEFAULT_LOCALE);
    });
};
export function useAllContractBeneficiaries({ contractId, enabled = true, }) {
    const shouldSkip = !contractId || !enabled;
    const { data, isLoading, isError, refetch } = useGetContractBeneficiariesQuery({
        voucherContractId: contractId ?? '',
        status: 'WORKING',
        sort: 'firstName',
    }, {
        skip: shouldSkip,
    });
    const processedBeneficiaries = useMemo(() => {
        if (isLoading || isError || !data?.result) {
            return [];
        }
        const workingBeneficiaries = filterWorkingBeneficiaries(data.result);
        const sortedBeneficiaries = sortBeneficiariesAlphabetically(workingBeneficiaries);
        return sortedBeneficiaries;
    }, [data?.result, isLoading, isError]);
    return {
        beneficiaries: processedBeneficiaries,
        total: processedBeneficiaries.length,
        isLoading,
        isError,
        refetch,
    };
}
